export default __webpack_public_path__ + "static/media/y.a87d0537.png";